import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Steve Jobs",
  "description": "",
  "published": "2011-10-06T00:00:00.000Z",
  "redirect_from": ["/blog/steve-jobs/swizec/2584"],
  "categories": "Apple, History, Pioneers, Pixar, Stanford University, Steve Job, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/2306432416_ffb32d9b31_m2.jpg",
        "alt": "Steve Jobs - Placard",
        "title": "Steve Jobs - Placard"
      }}></img></p>
    <p>{`A man died today. I never knew him personally and yet I feel like writing a post about his death before even getting out of bed this morning. When I went to bed last night, he wasn't dead yet, this morning, he was.`}</p>
    <p>{`Interesting how much can change in the world when you fall asleep for six hours. And people say sleep isn't a waste of time ...`}</p>
    <p>{`Sure, it was readily apparent that Steve Jobs would eventually die, not only is he just a man despite what many would like to believe, he also suffered from cancer and was visibly growing weaker over the past few years.`}</p>
    <p>{`A lot of people will remember him for being a great entrepreneur, many will think that it's really cool he could build two epic startups, create Pixar and then fix up his first startup into one of the most legendary technology companies currently in existence.`}</p>
    <p>{`But none of that really matters, his biggest impact on the world is simply being `}<em parentName="p">{`very fucking inspirational.`}</em>{` I will remember him most for the speech he held at Stanford in 2005.`}</p>
    <p>{`There are other important quotes by him and I'm sure the internet will be full of them for the next few days so I'm not going to post any.`}</p>
    <p>{`Just remember: stay foolish.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.marketingheadhunter.com/2011/10/steve-jobs-dont-settle.html"
        }}>{`STEVE JOBS: "Don't settle."`}</a>{` (marketingheadhunter.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://shawketali.wordpress.com/2011/10/06/remembering-steve-jobs/"
        }}>{`Remembering Steve Jobs`}</a>{` (shawketali.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.cbsnews.com/8301-504803_162-20116402-10391709.html"
        }}>{`"60 Minutes": The Steve Jobs interviews`}</a>{` (cbsnews.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=b0a358a0-e66c-4d3d-85af-bbed23da5556",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      